"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _css = require("@emotion/css");
var _legend = _interopRequireDefault(require("@amzn/meridian-tokens/component/legend"));
var _legendContext = _interopRequireDefault(require("./_legend-context"));
var _legendSymbol = _interopRequireDefault(require("./legend-symbol"));
var _theme = require("../theme");
var _token = require("./../_utils/token");
var _listReset = _interopRequireDefault(require("./../_styles/list-reset"));
var _text = _interopRequireDefault(require("./../_styles/text"));
var _focusRing = _interopRequireDefault(require("./../_styles/focus-ring"));
var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var direction = _ref.direction,
    withValues = _ref.withValues;
  return (0, _css.css)(_listReset["default"], (0, _text["default"])(t), {
    // The focus ring is shown on individual items in the legend
    outline: "none",
    display: "flex",
    flexDirection: direction === "horizontal" ? "row" : "column",
    flexWrap: direction === "horizontal" ? "wrap" : undefined,
    alignItems: direction === "vertical" && withValues ? "stretch" : "flex-start",
    // Use negative margins to counteract the padding on the legend items at
    // the top/right/bottom/left edges of the legend (these items can't be
    // targeted with CSS pseudo selectors because they may wrap/change). This
    // hack can sometimes cause weird layout issues (see the documentation for
    // the `wrap` prop on the Row component) when used near the top of the
    // DOM tree, but it should be fine for legends.
    margin: "-".concat(t("itemSpacingVertical") / 2, "px -").concat(t("itemSpacingHorizontal") / 2, "px")
  });
}, ["direction", "withValues"]);
var itemStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var state = _ref2.state,
    focus = _ref2.focus,
    clickable = _ref2.clickable;
  return (0, _css.css)((0, _focusRing["default"])(t.tokens, {
    focus: focus,
    borderRadius: t("itemBorderRadius")
  }), {
    display: "flex",
    alignItems: "center",
    maxWidth: "100%",
    boxSizing: "border-box",
    cursor: clickable ? "pointer" : undefined,
    // Apply half the item spacing all the way around the item. When items
    // are placed next to each other this will result in the desired spacing
    // without leaving any hover/click gaps between the items.
    padding: "".concat(t("itemSpacingVertical") / 2, "px ").concat(t("itemSpacingHorizontal") / 2, "px"),
    // Swatch styles
    "& > *:first-child": (0, _defineProperty2["default"])({
      flexShrink: 0,
      // Never squish swatches... the label will squish
      marginRight: t("swatchSpacingHorizontal"),
      transition: "opacity 0.1s ease",
      opacity: t("swatchOpacity", state) / 100
    }, "[dir=\"rtl\"] &", {
      marginRight: 0,
      marginLeft: t("swatchSpacingHorizontal")
    }),
    // Label styles
    "& > *:nth-child(2)": {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    // Value styles
    "& > *:nth-child(3)": (0, _defineProperty2["default"])({
      flexShrink: 0,
      // Never squish values... the label will squish
      marginLeft: "auto",
      // Right align values in columns
      paddingLeft: t("valueSpacingHorizontal")
    }, "[dir=\"rtl\"] &", {
      marginLeft: 0,
      paddingLeft: 0,
      marginRight: "auto",
      paddingRight: t("valueSpacingHorizontal")
    })
  });
}, ["state", "focus", "clickable"]);

/**
 * Render a legend for a data visualization. Place this component along with a
 * compatible data visualization inside the `LegendProvider` component.
 */
var Legend = function Legend(props) {
  var ariaLabels = props.ariaLabels,
    direction = props.direction,
    values = props.values,
    labels = props.labels;
  var t = (0, _theme.useTheme)(_legend["default"], "legend");
  var legend = (0, _react.useContext)(_legendContext["default"]);
  var items = [].concat((0, _toConsumableArray2["default"])(legend.data), (0, _toConsumableArray2["default"])(legend.supplementalItems));
  var withValues = items.map(function (item) {
    return values && values(item);
  }).some(function (value) {
    return value !== undefined;
  });
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);

  // NOTE: The extra div wrapper protects the negative margins on the ul element
  // from being reset by something like a Row or a Column layout parent.
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("ul", (0, _extends2["default"])({
    id: legend.id,
    role: "listbox",
    "aria-label": legend["aria-label"],
    "aria-labelledby": legend["aria-labelledby"],
    "aria-describedby": legend["aria-describedby"],
    "aria-activedescendant": legend.focusKey !== undefined ? "".concat(legend.id, "-item-").concat(legend.focusKey) : undefined,
    tabIndex: "0",
    onFocus: legend.onFocus,
    onBlur: legend.onBlur,
    onKeyDown: legend.onKeyDown,
    className: styles(t, {
      direction: direction,
      withValues: withValues
    })
  }, passThroughProps), items.map(function (item) {
    var state = legend.getState(item.key);
    var focus = legend.getFocus(item.key);
    var label = labels(item);
    var value = values && values(item);
    var hidden = item.showInLegend === false;
    // Render a legend item if it has a label and it either has a value or
    // no values are being shown at all.
    return label && (!withValues || value !== undefined) && !hidden ?
    /*#__PURE__*/
    // NOTE: keyboard interaction is handled up at the ul level.
    // See onKeyDown in legend-provider.js
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    _react["default"].createElement("li", {
      id: "".concat(legend.id, "-item-").concat(item.key),
      key: item.key,
      title: ariaLabels ? ariaLabels(item) : [label, value].filter(function (label) {
        return label !== undefined;
      }).join(", "),
      className: itemStyles(t, {
        state: state,
        focus: focus,
        clickable: item.onClick !== undefined
      }),
      onMouseDown: function onMouseDown() {
        return legend.setFocus(item.key);
      },
      onMouseEnter: function onMouseEnter() {
        return legend.setHover(item.key);
      },
      onMouseLeave: function onMouseLeave() {
        return legend.setHover();
      },
      onClick: item.onClick ? function () {
        return item.onClick(item);
      } : undefined,
      role: "option",
      "aria-selected": focus ? true : undefined
    }, /*#__PURE__*/_react["default"].createElement(_legendSymbol["default"], {
      color: item.color,
      type: item.symbol,
      size: item.size
    }), /*#__PURE__*/_react["default"].createElement("div", {
      "aria-hidden": true
    }, label), value ? /*#__PURE__*/_react["default"].createElement("div", {
      "aria-hidden": true
    }, value) : null) : null;
  })));
};
Legend.displayName = "Legend";
Legend.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A function that will return a screen-reader label for any given item in the
   * `data` array passed to `LegendProvider`. Use this if the visible label for
   * each legend item does not provide enough context for screen-reader users.
   */
  ariaLabels: _propTypes["default"].func,
  /**
   * All props prefaced with `data-` are accepted. These props will be passed
   * through to the underlying `ul` element contains all of the legend items.
   * This is useful for integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string,
  /**
   * The orientation of the legend.
   */
  direction: _propTypes["default"].oneOf(["horizontal", "vertical"]),
  /**
   * A function that will return the legend label to be displayed for any given
   * item in the `data` array passed to `LegendProvider`. By default this will
   * return the `label` field of each data item.
   */
  labels: _propTypes["default"].func,
  /**
   * A function that will return the value to be displayed for any given legend
   * item. The functional will be called for each item in the `data` array
   * passed to `LegendProvider` to generate the values. If this prop is not set
   * then no values will be shown in the legend.
   */
  values: _propTypes["default"].func
} : {};
Legend.defaultProps = {
  labels: function labels(_ref3) {
    var label = _ref3.label;
    return label;
  },
  direction: "vertical"
};
var _default = Legend;
exports["default"] = _default;